import * as actionTypes from "../../../actionTypes";
import * as api from "../../../../api/index";
import { toast } from "react-toastify";

export const GetScRuleFrameworksBIZcoreTD = (page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getScRuleFrameworksBIZcoreTD(page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_SC_RULE_FRAMEWORKS_BIZ_CORE_TD, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(error === "REQUEST_CANCELLED" ? true : false);
  }
};

export const GetScParseReviewsBIZcoreTD = (page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getScParseReviewsBIZcoreTD(page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_SC_PARSE_REVIEWS_BIZ_CORE_TD, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(error === "REQUEST_CANCELLED" ? true : false);
  }
};

export const GetScCh99RulesBIZcoreTD = (page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getScCh99RulesBIZcoreTD(page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_SC_CH99_RULES_BIZ_CORE_TD, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(error === "REQUEST_CANCELLED" ? true : false);
  }
};

export const GetScRuleInteractionsBIZcoreTD = (page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getScRuleInteractionsBIZcoreTD(page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_SC_RULE_INTERACTIONS_BIZ_CORE_TD, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(error === "REQUEST_CANCELLED" ? true : false);
  }
};

export const GetScHtsCh99MappingsBIZcoreTD = (page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getScHtsCh99MappingsBIZcoreTD(page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_SC_HTS_CH99_MAPPINGS_BIZ_CORE_TD, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(error === "REQUEST_CANCELLED" ? true : false);
  }
};

export const SeedCh99RulesBIZcoreTD = (setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.seedCh99RulesBIZcoreTD();
    if (status === 201) {
      toast.success(data.message || "Subchapter I data seeded successfully");
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

// ─── Ch99 Rule Engine sync (wipe / push to Alpha / push to Production) ───────

export const WipeCh99RulesBIZcoreTD = (setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.wipeCh99RulesBIZcoreTD();
    if (status === 201) {
      toast.success(data.message || "Ch99 rule engine tables wiped");
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetCh99RuleCoverageBIZcoreTD = (revisionId, setLoading, setCoverage) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  try {
    const { data, status } = await api.getCh99RuleCoverageBIZcoreTD(revisionId);
    if (status === 200) {
      if (setCoverage) setCoverage(data.data);
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    if (setLoading) setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    if (setLoading) setLoading(false);
  }
};

export const SimulateTariffBIZcoreTD = (form, setLoading, setResult) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.simulateTariffBIZcoreTD(form);
    if (status === 200) {
      setResult(data.data);
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

// Writes the Subchapter III pseudocode (notes 2, 16, 19, 36, 38) and compiles
// it into rules, interactions and HTS mappings in one transaction.
export const SeedCh99Subchapter3BIZcoreTD = (setLoading, setResult) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.seedCh99Subchapter3BIZcoreTD();
    if (status === 201) {
      const seeded = data.data || {};
      if (setResult) setResult(seeded);
      toast.success(
        `Seeded ${seeded.rules} rules, ${seeded.interactions} interactions, ${seeded.mappings} HTS mappings`
      );
      if (seeded.conversion_gap_count > 0) {
        toast.warn(`${seeded.conversion_gap_count} rule(s) stored with a CONVERSION_GAP — rate not in this revision's extract`);
      }
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetScPseudocodeBIZcoreTD = (page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getScPseudocodeBIZcoreTD(page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_SC_PSEUDOCODE_BIZ_CORE_TD, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(error === "REQUEST_CANCELLED" ? true : false);
  }
};

// ─── Batch seeding: one entry per group of Subchapter III notes ──────────────

export const GetCh99SeedBatchesBIZcoreTD = (setBatches) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  try {
    const { data, status } = await api.getCh99SeedBatchesBIZcoreTD();
    if (status === 200) setBatches(data.data || []);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  }
};

export const SeedCh99BatchBIZcoreTD = (batch, setLoading, setResult) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(batch);
  try {
    const { data, status } = await api.seedCh99BatchBIZcoreTD(batch);
    if (status === 201) {
      const seeded = data.data || {};
      if (setResult) setResult(seeded);
      toast.success(
        `Seeded ${seeded.rules} rules and ${seeded.pseudocode_records} pseudocode records across ${(seeded.revisions || []).length || Object.keys(seeded.per_batch || {}).length} revision(s)`
      );
      if (seeded.conversion_gap_count > 0) {
        toast.warn(`${seeded.conversion_gap_count} rule(s) stored with a CONVERSION_GAP — rate not resolvable`);
      }
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(null);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(null);
  }
};

export const GetCh99DeclarationRequirementsBIZcoreTD = (htsCode, setRequirements) => async (dispatch) => {
  try {
    const { data, status } = await api.getCh99DeclarationRequirementsBIZcoreTD(htsCode);
    if (status === 200) setRequirements(data.data?.required || []);
  } catch (error) {
    setRequirements([]);
  }
};
